import React, { useEffect, useState } from "react";
import useTable from "../../../../../components/useTable";
import axios from 'axios';
import moment from "moment/moment";
import { formatMoneda, nmes } from '../../../../../util/varios';
import { Input } from "../../../../../ui/inputs/Input";
import { AgregarCargo } from "../modals/modalAgregarCargo";
import { AgregarCurso } from "../modals/modalAgregarCurso";
import { AgregarProfesion } from "../modals/modalAgregarProfesion";

// ============================================
// CABECERAS PARA TABLA DE CARGOS (Departamentos donde ha prestado servicio)
// ============================================
const headCellsCargos = [
  {
    id: "fechaInicio",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Fecha Inicio",
    textAlign: "center",
  },
  {
    id: "fechaFin",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Fecha Fin",
    textAlign: "center",
  },
  {
    id: "departamento",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Departamento",
    textAlign: "center",
  },
  {
    id: "cargo",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Cargo",
    textAlign: "center",
  },
  {
    id: "observacion",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Observación",
    textAlign: "center",
  },
];

// ============================================
// CABECERAS PARA TABLA DE CURSOS (Certificación de Saberes-Talleres-Cursos)
// ============================================
const headCellsCursos = [
  {
    id: "mesAnio",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Mes/Año",
    textAlign: "center",
  },
  {
    id: "duracion",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Duración",
    textAlign: "center",
  },
  {
    id: "descripcion",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Descripción",
    textAlign: "center",
  },
  {
    id: "institucion",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Institución",
    textAlign: "center",
  },
  {
    id: "observacion",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Observación",
    textAlign: "center",
  },
];

// ============================================
// CABECERAS PARA TABLA DE PROFESIONES
// ============================================
const headCellsProfesiones = [
  {
    id: "gradoInstruccion",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Grado de Instrucción",
    textAlign: "center",
  },
  {
    id: "especialidad",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Especialidad",
    textAlign: "center",
  },
  {
    id: "mencion",
    backgroundColor: "rgba(5, 81, 130, 1)",
    color: "#ffffff",
    label: "Mención",
    textAlign: "center",
  },
];

export default function TablaDatosLaborales(props) {
  var op = require('../../../../../../src/modulos/datos');
  let token = localStorage.getItem('jwtToken');

  // Estados para Cargos
  const [recordsCargos, setRecordsCargos] = useState([]);
  const [filterFnCargos, setFilterFnCargos] = useState({
    fn: (items) => items,
  });

  // Estados para Cursos
  const [recordsCursos, setRecordsCursos] = useState([]);
  const [filterFnCursos, setFilterFnCursos] = useState({
    fn: (items) => items,
  });

  // Estados para Profesiones
  const [recordsProfesiones, setRecordsProfesiones] = useState([]);
  const [filterFnProfesiones, setFilterFnProfesiones] = useState({
    fn: (items) => items,
  });

  // Estados para modales
  const [mostrarModalCargo, setMostrarModalCargo] = useState(false);
  const [mostrarModalCurso, setMostrarModalCurso] = useState(false);
  const [mostrarModalProfesion, setMostrarModalProfesion] = useState(false);
  const [operacion, setOperacion] = useState(1);
  const [itemSeleccionado, setItemSeleccionado] = useState(null);
  const [tipoSeleccion, setTipoSeleccion] = useState(null);
  const [mensaje, setMensaje] = useState({ mostrar: false, titulo: "", texto: "", icono: "" });

  const [idMencionPrincipal, setIdMencionPrincipal] = useState(null);
  const [activate, setActivate] = useState(false);

  // ESTADO LOCAL - para modo local (operacion 1)
  const [datosLocales, setDatosLocales] = useState({
    cargos: [],
    cursos: [],
    profesiones: []
  });

  // Instancias de tablas
  const { TblContainer: TblContainerCargos, TblHead: TblHeadCargos, recordsAfterPagingAndSorting: recordsCargosAfterPaging } = useTable(
    props.operacionintegrante === 1 ? datosLocales.cargos : recordsCargos,
    headCellsCargos,
    filterFnCargos
  );

  const { TblContainer: TblContainerCursos, TblHead: TblHeadCursos, recordsAfterPagingAndSorting: recordsCursosAfterPaging } = useTable(
    props.operacionintegrante === 1 ? datosLocales.cursos : recordsCursos,
    headCellsCursos,
    filterFnCursos
  );

  const { TblContainer: TblContainerProfesiones, TblHead: TblHeadProfesiones, recordsAfterPagingAndSorting: recordsProfesionesAfterPaging } = useTable(
    props.operacionintegrante === 1 ? datosLocales.profesiones : recordsProfesiones,
    headCellsProfesiones,
    filterFnProfesiones
  );

  // Cargar datos según el modo
  useEffect(() => {
    if (props.codIntegrante) {
      if (props.operacionintegrante === 1) {
        // MODO LOCAL: empezar con arrays vacíos
        setDatosLocales({
          cargos: [],
          cursos: [],
          profesiones: []
        });
      } else {
        // MODO BD: cargar desde la base de datos
        seleccionarCargos(props.codIntegrante);
        seleccionarCursos(props.codIntegrante);
        obtenerMencionPrincipal(props.codIntegrante);
      }
    }
  }, [props.codIntegrante, props.operacionintegrante]);

  // ============================================
  // SELECCIONAR CARGOS (Departamentos donde ha prestado servicio)
  // ============================================
  const seleccionarCargos = (codIntegrante) => {
    if (!codIntegrante) return;

    let codigoNomina = localStorage.getItem('codigonomina')?.replace(/"/g, '');
    let esquema = `nomi${codigoNomina}`;
    let endpoint = `${op.conexion}/api/nomina/seleccionaridsesquema?esquema=${esquema}&id=${codIntegrante}&nomtab=cargosinte&nomid=codint&bloquear=true`;

    setActivate(true);
    axios.get(endpoint, {
      headers: { "x-access-token": `${token}` }
    })
      .then(response => {
        if (response.status === 200) {
          setRecordsCargos(response.data);
        }
      })
      .catch(error => {
        console.error("Error cargando cargos:", error);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: "Error al cargar cargos",
          icono: "error"
        });
      })
      .finally(() => setActivate(false));
  };



  // ============================================
  // OBTENER MENCIÓN PRINCIPAL DEL INTEGRANTE
  // ============================================
  const obtenerMencionPrincipal = (codIntegrante) => {
    if (!codIntegrante) return;

    let codigoNomina = localStorage.getItem('codigonomina')?.replace(/"/g, '');
    let esquema = `nomi${codigoNomina}`;
    let endpoint = `${op.conexion}/api/nomina/seleccionaridsesquema?esquema=${esquema}&id=${codIntegrante}&nomtab=integrantes&nomid=codint&bloquear=true`;

    axios.get(endpoint, {
      headers: { "x-access-token": `${token}` }
    })
      .then(response => {
        if (response.status === 200 && response.data.length > 0) {
          const mencion = response.data[0].mencion;
          setIdMencionPrincipal(mencion);
          if (mencion) {
            seleccionarProfesionesAdicionales(codIntegrante, mencion);
          } else {
            seleccionarTodasProfesiones(codIntegrante);
          }
        }
      })
      .catch(error => {
        console.error("Error obteniendo mención principal:", error);
      });
  };

  // ============================================
  // MEJORAR LA FUNCIÓN seleccionarProfesionesAdicionales PARA INCLUIR EL CÓDIGO
  // ============================================
  const seleccionarProfesionesAdicionales = (codIntegrante, idMencionPrincipal) => {
    if (!codIntegrante) return;

    let codigoNomina = localStorage.getItem('codigonomina')?.replace(/"/g, '');
    let esquema = `nomi${codigoNomina}`;

    let endpoint = `${op.conexion}/api/nomina/seleccionarprofesionesinteconprincipal?esquema=${esquema}&codint=${codIntegrante}&idmencionPrincipal=${idMencionPrincipal}`;

    setActivate(true);
    axios.get(endpoint, {
      headers: { "x-access-token": `${token}` }
    })
      .then(response => {
        if (response.status === 200) {
          // Asegurarnos de que cada profesión tenga su código
          const profesionesConCodigo = response.data.map(profesion => ({
            ...profesion,
            codigo: profesion.codigo // Asegurar que el código esté presente
          }));
          setRecordsProfesiones(profesionesConCodigo);
        }
      })
      .catch(error => {
        console.error("Error cargando profesiones:", error);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: "Error al cargar profesiones",
          icono: "error"
        });
      })
      .finally(() => setActivate(false));
  };

  // ============================================
  // MEJORAR LA FUNCIÓN seleccionarTodasProfesiones PARA INCLUIR EL CÓDIGO
  // ============================================
  const seleccionarTodasProfesiones = (codIntegrante) => {
    if (!codIntegrante) return;

    let codigoNomina = localStorage.getItem('codigonomina')?.replace(/"/g, '');
    let esquema = `nomi${codigoNomina}`;

    let endpoint = `${op.conexion}/api/nomina/seleccionarprofesionesinteconprincipal?esquema=${esquema}&codint=${codIntegrante}`;

    setActivate(true);
    axios.get(endpoint, {
      headers: { "x-access-token": `${token}` }
    })
      .then(response => {
        if (response.status === 200) {
          // Asegurarnos de que cada profesión tenga su código
          const profesionesConCodigo = response.data.map(profesion => ({
            ...profesion,
            codigo: profesion.codigo // Asegurar que el código esté presente
          }));
          setRecordsProfesiones(profesionesConCodigo);
        }
      })
      .catch(error => {
        console.error("Error cargando profesiones:", error);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: "Error al cargar profesiones",
          icono: "error"
        });
      })
      .finally(() => setActivate(false));
  };

  const gestionarCargo = (oper) => (e) => {
    e.preventDefault();

    // Validar que haya un item seleccionado para editar/eliminar/consultar
    if ((oper === 2 || oper === 3 || oper === 4) && (!itemSeleccionado || tipoSeleccion !== 'cargo')) {
      setMensaje({
        mostrar: true,
        titulo: "Advertencia",
        texto: "Debe seleccionar un cargo primero",
        icono: "warning"
      });
      return;
    }

    setOperacion(oper);
    setTipoSeleccion('cargo');
    setMostrarModalCargo(true);
  };

  const gestionarCurso = (oper) => (e) => {
    e.preventDefault();

    // Validar que haya un item seleccionado para editar/eliminar/consultar
    if ((oper === 2 || oper === 3 || oper === 4) && (!itemSeleccionado || tipoSeleccion !== 'curso')) {
      setMensaje({
        mostrar: true,
        titulo: "Advertencia",
        texto: "Debe seleccionar un curso primero",
        icono: "warning"
      });
      return;
    }

    setOperacion(oper);
    setTipoSeleccion('curso');
    setMostrarModalCurso(true);
  };

  const gestionarProfesion = (oper) => (e) => {
    e.preventDefault();

    // Validar que haya un item seleccionado para editar/eliminar/consultar
    if ((oper === 2 || oper === 3 || oper === 4) && (!itemSeleccionado || tipoSeleccion !== 'profesion')) {
      setMensaje({
        mostrar: true,
        titulo: "Advertencia",
        texto: "Debe seleccionar una profesión primero",
        icono: "warning"
      });
      return;
    }

    setOperacion(oper);
    setTipoSeleccion('profesion');
    setMostrarModalProfesion(true);
  };

  // ============================================
  // FUNCIÓN PARA ACTUALIZAR PROFESIÓN EN BD (MODO BD)
  // ============================================
  const actualizarProfesionBD = async (datos) => {
    if (!props.codIntegrante) return;

    let codigoNomina = localStorage.getItem('codigonomina')?.replace(/"/g, '');
    let esquema = `nomi${codigoNomina}`;

    setActivate(true);

    try {
      // --- CORRECCIÓN: Preparar el idMencion ---
      // El modal 'AgregarProfesion' envía datos con { idmencion, gradoinstruccion, especialidad, descripcion }
      // Necesitamos extraer el idmencion. Asumimos que viene en datos.idmencion.
      let idMencion = datos.idmencion;

      // Si es edición (operacion=2) y no viene el id en 'datos', lo obtenemos del itemSeleccionado.
      // El itemSeleccionado para profesión tiene la estructura { codigo, gradoinstruccion, especialidad, mencion, index }
      if (operacion === 2 && !idMencion && itemSeleccionado && itemSeleccionado.codigo) {
        idMencion = itemSeleccionado.codigo; // 'codigo' aquí es el idMencion
      }

      // Si es eliminación (operacion=3), tomamos el id del itemSeleccionado.
      if (operacion === 3 && itemSeleccionado && itemSeleccionado.codigo) {
        idMencion = itemSeleccionado.codigo;
      }

      // --- CORRECCIÓN: Preparar el objeto a enviar (SIN ANIDAR) ---
      // El backend espera recibir directamente p_codint, p_idmencion, p_esquema
      const datosParaBackend = {
        p_codint: props.codIntegrante,
        p_idmencion: idMencion || 0, // Enviar 0 si es una nueva inclusión
        p_esquema: esquema
      };

      console.log('Enviando datos de profesión al backend (CORREGIDO):', datosParaBackend);

      const response = await axios({
        method: 'POST',
        url: `${op.conexion}/api/nomina/profesionesinte_act?operacion=${operacion}`,
        data: datosParaBackend, // Enviamos el objeto corregido
        headers: { "x-access-token": `${token}` }
      });

      if (response.status === 200) {
        // Recargar la lista después de la operación
        if (idMencionPrincipal) {
          await seleccionarProfesionesAdicionales(props.codIntegrante, idMencionPrincipal);
        } else {
          await seleccionarTodasProfesiones(props.codIntegrante);
        }

        setMensaje({
          mostrar: true,
          titulo: "Éxito",
          texto: `Profesión ${operacion === 1 ? 'agregada' : operacion === 2 ? 'actualizada' : 'eliminada'} correctamente`,
          icono: "success"
        });

        // Limpiar selección
        setItemSeleccionado(null);
      }
    } catch (error) {
      console.error("Error en operación con profesión:", error);
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: error.response?.data?.message || "Error al procesar la solicitud",
        icono: "error"
      });
    } finally {
      setActivate(false);
    }
  };
  // ============================================
  // FUNCIÓN PARA ELIMINAR PROFESIÓN EN BD
  // ============================================
  const eliminarProfesionBD = async () => {
    if (!props.codIntegrante || !itemSeleccionado) return;

    let codigoNomina = localStorage.getItem('codigonomina')?.replace(/"/g, '');
    let esquema = `nomi${codigoNomina}`;

    setActivate(true);

    try {
      // Para eliminar, necesitamos el código de la profesión
      const datosEliminar = {
        ncodigo: itemSeleccionado.codigo || 0,
        ccodint: props.codIntegrante,
        cgradoinstruccion: '',
        cespecialidad: '',
        cmencion: '',
        esquema1: esquema
      };

      const response = await axios({
        method: 'POST',
        url: `${op.conexion}/api/nomina/profesionesinte_act?operacion=3`,
        data: datosEliminar,
        headers: { "x-access-token": `${token}` }
      });

      if (response.status === 200) {
        if (idMencionPrincipal) {
          await seleccionarProfesionesAdicionales(props.codIntegrante, idMencionPrincipal);
        } else {
          await seleccionarTodasProfesiones(props.codIntegrante);
        }

        setMensaje({
          mostrar: true,
          titulo: "Éxito",
          texto: "Profesión eliminada correctamente",
          icono: "success"
        });

        setItemSeleccionado(null);
      }
    } catch (error) {
      console.error("Error eliminando profesión:", error);
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: error.response?.data?.message || "Error al eliminar la profesión",
        icono: "error"
      });
    } finally {
      setActivate(false);
    }
  };

  // ============================================
  // FUNCIÓN PARA ACTUALIZAR CURSO EN BD (MODO BD)
  // ============================================
  const actualizarCursoBD = async (datos) => {
    if (!props.codIntegrante) return;

    let codigoNomina = localStorage.getItem('codigonomina')?.replace(/"/g, '');
    let esquema = `nomi${codigoNomina}`;

    setActivate(true);

    try {
      // Para incluir (operacion=1), necesitamos obtener el próximo código
      // El backend lo calculará automáticamente si enviamos ncodigo=0
      let ncodigo = 0;

      // Si es edición (operacion=2), necesitamos el código del curso seleccionado
      if (operacion === 2 && itemSeleccionado && itemSeleccionado.codigo) {
        ncodigo = itemSeleccionado.codigo;
      }

      // Si es eliminación (operacion=3), también necesitamos el código
      if (operacion === 3 && itemSeleccionado && itemSeleccionado.codigo) {
        ncodigo = itemSeleccionado.codigo;
      }

      // Preparar los datos en el formato que espera la función PostgreSQL
      const datosCurso = {
        ncodigo: ncodigo,
        ccodint: props.codIntegrante,
        cdescripcion: datos.descripcion || '',
        cinstitucion: datos.institucion || '',
        cduracion: datos.duracion || '',
        cmes: nmes(datos.mes) || '',
        canio: parseInt(datos.anio) || 0,
        cobservacion: datos.observacion || '',
        esquema1: esquema
      };

      console.log('Enviando datos de curso:', datosCurso);

      const response = await axios({
        method: 'POST',
        url: `${op.conexion}/api/nomina/cursosinte_act?operacion=${operacion}`,
        data: datosCurso,
        headers: { "x-access-token": `${token}` }
      });

      if (response.status === 200) {
        // Recargar la lista después de la operación
        await seleccionarCursos(props.codIntegrante);

        setMensaje({
          mostrar: true,
          titulo: "Éxito",
          texto: `Curso ${operacion === 1 ? 'agregado' : operacion === 2 ? 'actualizado' : 'eliminado'} correctamente`,
          icono: "success"
        });

        // Limpiar selección
        setItemSeleccionado(null);
      }
    } catch (error) {
      console.error("Error en operación con curso:", error);
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: error.response?.data?.message || "Error al procesar la solicitud",
        icono: "error"
      });
    } finally {
      setActivate(false);
    }
  };

  // ============================================
  // FUNCIÓN PARA ELIMINAR CURSO EN BD
  // ============================================
  const eliminarCursoBD = async () => {
    if (!props.codIntegrante || !itemSeleccionado) return;

    let codigoNomina = localStorage.getItem('codigonomina')?.replace(/"/g, '');
    let esquema = `nomi${codigoNomina}`;

    setActivate(true);

    try {
      // Para eliminar, necesitamos el código del curso
      const datosEliminar = {
        ncodigo: itemSeleccionado.codigo || 0,
        ccodint: props.codIntegrante,
        cdescripcion: '',
        cinstitucion: '',
        cduracion: '',
        cmes: '',
        canio: 0,
        cobservacion: '',
        esquema1: esquema
      };

      const response = await axios({
        method: 'POST',
        url: `${op.conexion}/api/nomina/cursosinte_act?operacion=3`,
        data: datosEliminar,
        headers: { "x-access-token": `${token}` }
      });

      if (response.status === 200) {
        await seleccionarCursos(props.codIntegrante);

        setMensaje({
          mostrar: true,
          titulo: "Éxito",
          texto: "Curso eliminado correctamente",
          icono: "success"
        });

        setItemSeleccionado(null);
      }
    } catch (error) {
      console.error("Error eliminando curso:", error);
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: error.response?.data?.message || "Error al eliminar el curso",
        icono: "error"
      });
    } finally {
      setActivate(false);
    }
  };

  // ============================================
  // MEJORAR LA FUNCIÓN seleccionarCursos PARA INCLUIR EL CÓDIGO 111111
  // ============================================
  const seleccionarCursos = (codIntegrante) => {
    if (!codIntegrante) return;

    let codigoNomina = localStorage.getItem('codigonomina')?.replace(/"/g, '');
    let esquema = `nomi${codigoNomina}`;
    let endpoint = `${op.conexion}/api/nomina/seleccionaridsesquema?esquema=${esquema}&id=${codIntegrante}&nomtab=cursosinte&nomid=codint&bloquear=true`;

    setActivate(true);
    axios.get(endpoint, {
      headers: { "x-access-token": `${token}` }
    })
      .then(response => {
        if (response.status === 200) {
          // Asegurarnos de que cada curso tenga su código
          const cursosConCodigo = response.data.map(curso => ({
            ...curso,
            codigo: curso.codigo // Asegurar que el código esté presente
          }));
          setRecordsCursos(cursosConCodigo);
        }
      })
      .catch(error => {
        console.error("Error cargando cursos:", error);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: "Error al cargar cursos",
          icono: "error"
        });
      })
      .finally(() => setActivate(false));
  };

  // ============================================
  // ACTUALIZAR LA FUNCIÓN seleccionarFila PARA INCLUIR EL CÓDIGO 11111
  // ============================================
  const seleccionarFila = (tipo, item, index) => (e) => {
    e.preventDefault();

    let itemParaModal;

    if (tipo === 'cargo') {
      itemParaModal = [
        item.fechaini,
        item.fechafin,
        item.nomdep,
        item.nomcar,
        item.observacion,
        {
          index: index,
          codigo: item.codigo  // Incluir código si existe
        }
      ];
    } else if (tipo === 'curso') {
      itemParaModal = {
        codigo: item.codigo,      // Incluir código para edición/eliminación
        mes: item.mes,
        anio: item.anio,
        duracion: item.duracion,
        descripcion: item.descripcion,
        institucion: item.institucion,
        observacion: item.observacion,
        index: index
      };
    } else if (tipo === 'profesion') {
      itemParaModal = {
        codigo: item.codigo,  // Incluir código para edición/eliminación
        gradoinstruccion: item.gradoinstruccion,
        especialidad: item.especialidad,
        mencion: item.descripcion,  // Mapear descripción a mención
        index: index
      };
    }

    setTipoSeleccion(tipo);
    setItemSeleccionado(itemParaModal);
    console.log('Item seleccionado:', itemParaModal);
  };

  // ============================================
  // HANDLER PARA EL MODAL DE CURSO (ACTUALIZADO)
  // ============================================
  const handleAceptarModalCurso = (datos) => {
    if (props.operacionintegrante === 1) {
      // ===== MODO LOCAL =====
      let nuevosCursos = [...datosLocales.cursos];

      if (operacion === 1) {
        // INCLUIR - Nuevo curso
        // Validar que no exista un curso con la misma descripción, mes y año
        const existe = nuevosCursos.some(curso =>
          curso.descripcion?.toUpperCase() === datos.descripcion?.toUpperCase() &&
          curso.mes === datos.mes &&
          curso.anio === datos.anio
        );

        if (existe) {
          setMensaje({
            mostrar: true,
            titulo: 'Error',
            texto: 'El curso ya existe con la misma descripción, mes y año',
            icono: 'error'
          });
          return;
        }

        nuevosCursos.push({
          mes: datos.mes,
          anio: datos.anio,
          duracion: datos.duracion,
          descripcion: datos.descripcion,
          institucion: datos.institucion,
          observacion: datos.observacion
        });

      } else if (operacion === 2) {
        // EDITAR - Modificar curso existente
        if (itemSeleccionado && itemSeleccionado.index !== undefined) {
          const index = itemSeleccionado.index;

          // Validar que no exista otro curso con la misma descripción, mes y año (excepto el actual)
          const existe = nuevosCursos.some((curso, i) =>
            i !== index &&
            curso.descripcion?.toUpperCase() === datos.descripcion?.toUpperCase() &&
            curso.mes === datos.mes &&
            curso.anio === datos.anio
          );

          if (existe) {
            setMensaje({
              mostrar: true,
              titulo: 'Error',
              texto: 'Ya existe otro curso con la misma descripción, mes y año',
              icono: 'error'
            });
            return;
          }

          nuevosCursos[index] = {
            ...nuevosCursos[index],
            mes: datos.mes || nuevosCursos[index].mes,
            anio: datos.anio || nuevosCursos[index].anio,
            duracion: datos.duracion || nuevosCursos[index].duracion,
            descripcion: datos.descripcion || nuevosCursos[index].descripcion,
            institucion: datos.institucion || nuevosCursos[index].institucion,
            observacion: datos.observacion || nuevosCursos[index].observacion
          };
        }

      } else if (operacion === 3) {
        // ELIMINAR - Borrar curso
        if (itemSeleccionado && itemSeleccionado.index !== undefined) {
          nuevosCursos = nuevosCursos.filter((_, i) => i !== itemSeleccionado.index);
        }
      }

      // Actualizar el estado local
      setDatosLocales(prev => ({
        ...prev,
        cursos: nuevosCursos
      }));

      // Notificar al padre si existe la función
      if (props.onDataChange) {
        props.onDataChange('cursos', nuevosCursos);
      }

    } else {
      // ===== MODO BD =====
      if (operacion === 3) {
        // Eliminar
        eliminarCursoBD();
      } else {
        // Incluir o Editar
        actualizarCursoBD(datos);
      }
    }

    setMostrarModalCurso(false);
    setItemSeleccionado(null);
  };



  // ============================================
  // FUNCIÓN PARA ACTUALIZAR CARGO EN BD (MODO BD)
  // ============================================
  const actualizarCargoBD = async (datos) => {
    if (!props.codIntegrante) return;

    let codigoNomina = localStorage.getItem('codigonomina')?.replace(/"/g, '');
    let esquema = `nomi${codigoNomina}`;

    setActivate(true);

    try {
      // Preparar los datos en el formato que espera el backend
      const datosCargo = {
        ccodint: props.codIntegrante,           // Código del integrante
        cnomcar: datos.nomcar,                   // Nombre del cargo
        cnomdep: datos.nomdep,                   // Nombre del departamento
        fecini: datos.fechaini,                   // Fecha inicio (formato DD/MM/AAAA)
        fecfin: datos.fechafin,                   // Fecha fin (formato DD/MM/AAAA)
        cobservacion: datos.observacion,          // Observación
        esquema1: esquema                         // Esquema de la base de datos
      };

      console.log('Enviando datos de cargo:', datosCargo);

      const response = await axios({
        method: 'POST',
        url: `${op.conexion}/api/nomina/cargosinte_act?operacion=${operacion}`,
        data: datosCargo,
        headers: { "x-access-token": `${token}` }
      });

      if (response.status === 200) {
        // Recargar la lista después de la operación
        await seleccionarCargos(props.codIntegrante);

        setMensaje({
          mostrar: true,
          titulo: "Éxito",
          texto: `Cargo ${operacion === 1 ? 'agregado' : operacion === 2 ? 'actualizado' : 'eliminado'} correctamente`,
          icono: "success"
        });

        // Limpiar selección
        setItemSeleccionado(null);
      }
    } catch (error) {
      console.error("Error en operación con cargo:", error);
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: error.response?.data?.message || "Error al procesar la solicitud",
        icono: "error"
      });
    } finally {
      setActivate(false);
    }
  };


  // ============================================
  // FUNCIÓN PARA ELIMINAR CARGO EN BD
  // ============================================
  const eliminarCargoBD = async () => {
    if (!props.codIntegrante || !itemSeleccionado) return;

    let codigoNomina = localStorage.getItem('codigonomina')?.replace(/"/g, '');
    let esquema = `nomi${codigoNomina}`;

    setActivate(true);

    try {
      // Para eliminar, necesitamos los datos que identifican el cargo
      // Usamos el código del integrante y las fechas para identificar el registro
      const datosEliminar = {
        ccodint: props.codIntegrante,
        fecini: itemSeleccionado[0],  // Fecha inicio del cargo seleccionado
        esquema1: esquema
      };

      const response = await axios({
        method: 'DELETE',
        url: `${op.conexion}/api/nomina/cargosinte_act?operacion=3`,
        data: datosEliminar,
        headers: { "x-access-token": `${token}` }
      });

      if (response.status === 200) {
        await seleccionarCargos(props.codIntegrante);

        setMensaje({
          mostrar: true,
          titulo: "Éxito",
          texto: "Cargo eliminado correctamente",
          icono: "success"
        });

        setItemSeleccionado(null);
      }
    } catch (error) {
      console.error("Error eliminando cargo:", error);
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: error.response?.data?.message || "Error al eliminar el cargo",
        icono: "error"
      });
    } finally {
      setActivate(false);
    }
  };

  const handleAceptarModalCargo = (datos) => {
    if (props.operacionintegrante === 1) {
      // ===== MODO LOCAL =====
      let nuevosCargos = [...datosLocales.cargos];

      if (operacion === 1) {
        // INCLUIR - Nuevo cargo
        // Validar que no exista un cargo con la misma fecha de inicio y nombre
        const existe = nuevosCargos.some(cargo =>
          cargo.nomcar?.toUpperCase() === datos.nomcar?.toUpperCase() &&
          cargo.fechaini === datos.fechaini
        );

        if (existe) {
          setMensaje({
            mostrar: true,
            titulo: 'Error',
            texto: 'El cargo ya existe con la misma fecha de inicio',
            icono: 'error'
          });
          return;
        }

        nuevosCargos.push({
          fechaini: datos.fechaini,
          fechafin: datos.fechafin || null,
          nomdep: datos.nomdep,
          nomcar: datos.nomcar,
          observacion: datos.observacion || ""
        });

      } else if (operacion === 2) {
        // EDITAR - Modificar cargo existente
        if (itemSeleccionado && itemSeleccionado[5]?.index !== undefined) {
          const index = itemSeleccionado[5].index;

          // Validar que no exista otro cargo con la misma fecha (excepto el actual)
          const existe = nuevosCargos.some((cargo, i) =>
            i !== index &&
            cargo.nomcar?.toUpperCase() === datos.nomcar?.toUpperCase() &&
            cargo.fechaini === datos.fechaini
          );

          if (existe) {
            setMensaje({
              mostrar: true,
              titulo: 'Error',
              texto: 'Ya existe otro cargo con la misma fecha de inicio',
              icono: 'error'
            });
            return;
          }

          nuevosCargos[index] = {
            ...nuevosCargos[index],
            fechaini: datos.fechaini || nuevosCargos[index].fechaini,
            fechafin: datos.fechafin || nuevosCargos[index].fechafin,
            nomdep: datos.nomdep || nuevosCargos[index].nomdep,
            nomcar: datos.nomcar || nuevosCargos[index].nomcar,
            observacion: datos.observacion || nuevosCargos[index].observacion
          };
        }

      } else if (operacion === 3) {
        // ELIMINAR - Borrar cargo
        if (itemSeleccionado && itemSeleccionado[5]?.index !== undefined) {
          nuevosCargos = nuevosCargos.filter((_, i) => i !== itemSeleccionado[5].index);
        }
      }

      // Actualizar el estado local
      setDatosLocales(prev => ({
        ...prev,
        cargos: nuevosCargos
      }));

      // Notificar al padre si existe la función
      if (props.onDataChange) {
        props.onDataChange('cargos', nuevosCargos);
      }

    } else {
      // ===== MODO BD =====
      if (operacion === 3) {
        // Eliminar
        eliminarCargoBD();
      } else {
        // Incluir o Editar
        actualizarCargoBD(datos);
      }
    }

    setMostrarModalCargo(false);
    setItemSeleccionado(null);
  };


  // ============================================
  // ACTUALIZAR EL HANDLER DEL MODAL DE PROFESIÓN
  // ============================================
  const handleAceptarModalProfesion = (datos) => {
    if (props.operacionintegrante === 1) {
      // ===== MODO LOCAL =====
      let nuevasProfesiones = [...datosLocales.profesiones];

      if (operacion === 1) {
        // INCLUIR - Nueva profesión
        // Validar que no exista una profesión con el mismo grado, especialidad y mención
        const existe = nuevasProfesiones.some(prof =>
          prof.gradoinstruccion?.toUpperCase() === datos.gradoinstruccion?.toUpperCase() &&
          prof.especialidad?.toUpperCase() === datos.especialidad?.toUpperCase() &&
          prof.descripcion?.toUpperCase() === datos.mencion?.toUpperCase()
        );

        if (existe) {
          setMensaje({
            mostrar: true,
            titulo: 'Error',
            texto: 'La profesión ya existe con el mismo grado, especialidad y mención',
            icono: 'error'
          });
          return;
        }

        nuevasProfesiones.push({
          gradoinstruccion: datos.gradoinstruccion,
          especialidad: datos.especialidad,
          descripcion: datos.mencion
        });

      } else if (operacion === 2) {
        // EDITAR - Modificar profesión existente
        if (itemSeleccionado && itemSeleccionado.index !== undefined) {
          const index = itemSeleccionado.index;

          // Validar que no exista otra profesión con los mismos datos (excepto la actual)
          const existe = nuevasProfesiones.some((prof, i) =>
            i !== index &&
            prof.gradoinstruccion?.toUpperCase() === datos.gradoinstruccion?.toUpperCase() &&
            prof.especialidad?.toUpperCase() === datos.especialidad?.toUpperCase() &&
            prof.descripcion?.toUpperCase() === datos.mencion?.toUpperCase()
          );

          if (existe) {
            setMensaje({
              mostrar: true,
              titulo: 'Error',
              texto: 'Ya existe otra profesión con el mismo grado, especialidad y mención',
              icono: 'error'
            });
            return;
          }

          nuevasProfesiones[index] = {
            ...nuevasProfesiones[index],
            gradoinstruccion: datos.gradoinstruccion || nuevasProfesiones[index].gradoinstruccion,
            especialidad: datos.especialidad || nuevasProfesiones[index].especialidad,
            descripcion: datos.mencion || nuevasProfesiones[index].descripcion
          };
        }

      } else if (operacion === 3) {
        // ELIMINAR - Borrar profesión
        if (itemSeleccionado && itemSeleccionado.index !== undefined) {
          nuevasProfesiones = nuevasProfesiones.filter((_, i) => i !== itemSeleccionado.index);
        }
      }

      // Actualizar el estado local
      setDatosLocales(prev => ({
        ...prev,
        profesiones: nuevasProfesiones
      }));

      // Notificar al padre si existe la función
      if (props.onDataChange) {
        props.onDataChange('profesiones', nuevasProfesiones);
      }

    } else {
      // ===== MODO BD =====
      if (operacion === 3) {
        // Eliminar
        eliminarProfesionBD();
      } else {
        // Incluir o Editar
        actualizarProfesionBD(datos);
      }
    }

    setMostrarModalProfesion(false);
    setItemSeleccionado(null);
  };
  // Formatear fecha para mostrar
  const formatearFecha = (fecha) => {
    if (!fecha) return '';
    return moment.utc(fecha).format('DD/MM/YYYY');
  };

  const dataSourceCargos = props.operacionintegrante === 1 ? datosLocales.cargos : recordsCargos;
  const dataSourceCursos = props.operacionintegrante === 1 ? datosLocales.cursos : recordsCursos;
  const dataSourceProfesiones = props.operacionintegrante === 1 ? datosLocales.profesiones : recordsProfesiones;

  return (
    <div className="col-12 m-0 p-0 d-flex flex-wrap">
      {/* Mensaje de notificación */}
      {mensaje.mostrar && (
        <div className={`alert alert-${mensaje.icono === 'error' ? 'danger' : mensaje.icono === 'success' ? 'success' : 'warning'} alert-dismissible fade show mb-2 col-12`} role="alert">
          <strong>{mensaje.titulo}:</strong> {mensaje.texto}
          <button type="button" className="close" onClick={() => setMensaje({ ...mensaje, mostrar: false })}>
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      )}

      {/* TABLA DE CARGOS (Departamentos donde ha prestado servicio) */}
      <fieldset className="col-12 m-0 p-2 mb-3 border-azul rounded">
        <legend className="w-auto m-0 float-none">Departamentos donde ha prestado Servicio</legend>

        <div className="col-12 m-0 p-0 d-flex">
          <div className="col-11 m-0 p-0">
            <TblContainerCargos>
              <TblHeadCargos />
              <tbody>
                {dataSourceCargos?.length > 0 ? (
                  dataSourceCargos.map((item, index) => (
                    <tr
                      key={index}
                      style={{
                        cursor: props.operacionintegrante === 1 ? 'pointer' : 'default',
                        background: itemSeleccionado &&
                          tipoSeleccion === 'cargo' &&
                          ((props.operacionintegrante === 1 && itemSeleccionado[5]?.index === index) ||
                            (props.operacionintegrante !== 1 && itemSeleccionado.index === index))
                          ? "lightskyblue" : "white"
                      }}
                      onClick={props.operacionintegrante === 1 ? seleccionarFila('cargo', item, index) : undefined}
                    >
                      <td className="text-center">{formatearFecha(item.fechaini)}</td>
                      <td className="text-center">{formatearFecha(item.fechafin)}</td>
                      <td className="text-left">{item.nomdep || ''}</td>
                      <td className="text-left">{item.nomcar || ''}</td>
                      <td className="text-left">{item.observacion || ''}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center">
                      {activate ? 'Cargando...' : 'No hay cargos registrados'}
                    </td>
                  </tr>
                )}
              </tbody>
            </TblContainerCargos>
          </div>


          <div className="col-1 m-0 p-0 d-flex flex-column gap-2 align-items-center justify-content-center">
            <div className="col-auto m-0 p-0">
              <button
                type="button"
                className="btn btn-info rounded-circle"
                onClick={gestionarCargo(4)}
                disabled={dataSourceCargos.length === 0 || !itemSeleccionado || tipoSeleccion !== 'cargo' || activate}
                title="Consultar"
              >
                <i className="fa fa-eye"></i>
              </button>
            </div>
            <div className="col-auto m-0 p-0">
              <button
                type="button"
                className="btn btn-primary rounded-circle"
                onClick={gestionarCargo(1)}
                disabled={activate}
                title="Incluir"
              >
                <i className="fa fa-plus"></i>
              </button>
            </div>
            <div className="col-auto m-0 p-0">
              <button
                type="button"
                className="btn btn-danger rounded-circle"
                onClick={gestionarCargo(3)}
                disabled={!itemSeleccionado || tipoSeleccion !== 'cargo' || activate}
                title="Eliminar"
              >
                <i className="fa fa-trash-alt"></i>
              </button>
            </div>
            <div className="col-auto m-0 p-0">
              <button
                type="button"
                className="btn btn-warning rounded-circle"
                onClick={gestionarCargo(2)}
                disabled={!itemSeleccionado || tipoSeleccion !== 'cargo' || activate}
                title="Editar"
              >
                <i className="fa fa-edit"></i>
              </button>
            </div>
          </div>

        </div>
      </fieldset>

      {/* TABLA DE CURSOS (Certificación de Saberes-Talleres-Cursos) */}
      <fieldset className="col-12 m-0 p-2 mb-3 border-azul rounded">
        <legend className="w-auto m-0 float-none">Certificación de Saberes-Talleres-Cursos</legend>

        <div className="col-12 m-0 p-0 d-flex">
          <div className="col-11 m-0 p-0">
            <TblContainerCursos>
              <TblHeadCursos />
              <tbody>
                {dataSourceCursos?.length > 0 ? (
                  dataSourceCursos.map((item, index) => (
                    <tr
                      key={index}
                      style={{
                        cursor: props.operacionintegrante === 1 ? 'pointer' : 'default',
                        background: itemSeleccionado?.index === index && tipoSeleccion === 'curso' ? "lightskyblue" : "white"
                      }}
                      onClick={props.operacionintegrante === 1 ? seleccionarFila('curso', item, index) : undefined}
                    >
                      <td className="text-center">
                        {item.mes && item.anio ? `${String(item.mes).padStart(2, '0')}/${item.anio}` : ''}
                      </td>
                      <td className="text-left">{item.duracion || ''}</td>
                      <td className="text-left">{item.descripcion || ''}</td>
                      <td className="text-left">{item.institucion || ''}</td>
                      <td className="text-left">{item.observacion || ''}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center">
                      {activate ? 'Cargando...' : 'No hay cursos registrados'}
                    </td>
                  </tr>
                )}
              </tbody>
            </TblContainerCursos>
          </div>


          <div className="col-1 m-0 p-0 d-flex flex-column gap-2 align-items-center justify-content-center">
            <div className="col-auto m-0 p-0">
              <button
                type="button"
                className="btn btn-info rounded-circle"
                onClick={gestionarCurso(4)}
                disabled={dataSourceCursos.length === 0 || !itemSeleccionado || tipoSeleccion !== 'curso' || activate}
                title="Consultar"
              >
                <i className="fa fa-eye"></i>
              </button>
            </div>
            <div className="col-auto m-0 p-0">
              <button
                type="button"
                className="btn btn-primary rounded-circle"
                onClick={gestionarCurso(1)}
                disabled={activate}
                title="Incluir"
              >
                <i className="fa fa-plus"></i>
              </button>
            </div>
            <div className="col-auto m-0 p-0">
              <button
                type="button"
                className="btn btn-danger rounded-circle"
                onClick={gestionarCurso(3)}
                disabled={!itemSeleccionado || tipoSeleccion !== 'curso' || activate}
                title="Eliminar"
              >
                <i className="fa fa-trash-alt"></i>
              </button>
            </div>
            <div className="col-auto m-0 p-0">
              <button
                type="button"
                className="btn btn-warning rounded-circle"
                onClick={gestionarCurso(2)}
                disabled={!itemSeleccionado || tipoSeleccion !== 'curso' || activate}
                title="Editar"
              >
                <i className="fa fa-edit"></i>
              </button>
            </div>
          </div>
        </div>
      </fieldset>

      {/* TABLA DE PROFESIONES */}
      <fieldset className="col-12 m-0 p-2 mb-3 border-azul rounded">
        <legend className="w-auto m-0 float-none">Profesiones</legend>

        <div className="col-12 m-0 p-0 d-flex">
          <div className="col-11 m-0 p-0">
            <TblContainerProfesiones>
              <TblHeadProfesiones />
              <tbody>
                {dataSourceProfesiones?.length > 0 ? (
                  dataSourceProfesiones.map((item, index) => (
                    <tr
                      key={index}
                      style={{
                        cursor: props.operacionintegrante === 1 ? 'pointer' : 'default',
                        background: itemSeleccionado?.index === index && tipoSeleccion === 'profesion' ? "lightskyblue" : "white"
                      }}
                      onClick={props.operacionintegrante === 1 ? seleccionarFila('profesion', item, index) : undefined}
                    >
                      <td className="text-center">{item.gradoinstruccion || ''}</td>
                      <td className="text-center">{item.especialidad || ''}</td>
                      <td className="text-center">{item.descripcion || ''}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="3" className="text-center">
                      {activate ? 'Cargando...' : 'No hay profesiones registradas'}
                    </td>
                  </tr>
                )}
              </tbody>
            </TblContainerProfesiones>
          </div>


          <div className="col-1 m-0 p-0 d-flex flex-column gap-2 align-items-center justify-content-center">
            <div className="col-auto m-0 p-0">
              <button
                type="button"
                className="btn btn-info rounded-circle"
                onClick={gestionarProfesion(4)}
                disabled={dataSourceProfesiones.length === 0 || !itemSeleccionado || tipoSeleccion !== 'profesion' || activate}
                title="Consultar"
              >
                <i className="fa fa-eye"></i>
              </button>
            </div>
            <div className="col-auto m-0 p-0">
              <button
                type="button"
                className="btn btn-primary rounded-circle"
                onClick={gestionarProfesion(1)}
                disabled={activate}
                title="Incluir"
              >
                <i className="fa fa-plus"></i>
              </button>
            </div>
            <div className="col-auto m-0 p-0">
              <button
                type="button"
                className="btn btn-danger rounded-circle"
                onClick={gestionarProfesion(3)}
                disabled={!itemSeleccionado || tipoSeleccion !== 'profesion' || activate}
                title="Eliminar"
              >
                <i className="fa fa-trash-alt"></i>
              </button>
            </div>
            <div className="col-auto m-0 p-0">
              <button
                type="button"
                className="btn btn-warning rounded-circle"
                onClick={gestionarProfesion(2)}
                disabled={!itemSeleccionado || tipoSeleccion !== 'profesion' || activate}
                title="Editar"
              >
                <i className="fa fa-edit"></i>
              </button>
            </div>
          </div>

        </div>
      </fieldset>

      {/* Modales */}
      <AgregarCargo
        show={mostrarModalCargo}
        onHide={() => {
          setMostrarModalCargo(false);
          setItemSeleccionado(null);
        }}
        operacion={operacion}
        datos={itemSeleccionado}
        onAceptar={handleAceptarModalCargo}
      />

      <AgregarCurso
        show={mostrarModalCurso}
        onHide={() => {
          setMostrarModalCurso(false);
          setItemSeleccionado(null);
        }}
        operacion={operacion}
        datos={itemSeleccionado}
        onAceptar={handleAceptarModalCurso}
      />

      <AgregarProfesion
        show={mostrarModalProfesion}
        onHide={() => {
          setMostrarModalProfesion(false);
          setItemSeleccionado(null);
        }}
        operacion={operacion}
        datos={itemSeleccionado}
        onAceptar={handleAceptarModalProfesion}
      />
    </div>
  );
}